<div class="w-full">
  <!--BLUE BAR-->
  <div class="horiz-bar bg-primary"></div>
  <!--TITLE-->
  <div class="flex justify-content-between align-items-center flex-wrap mb-4 mt-4">
    <div class="flex justify-content-between align-items-center">
      <div class="text-800 text-3xl font-medium mr-4">{{ 'MYOPIA_RISK_SCORE_PREDICTION_TITLE' | translate }}</div>
      <div class="border-round-2xl px-2 py-1" [ngStyle]="{ backgroundColor: riskColor, color: riskColorText }">
        {{ catagoryTranslationKeys[premyopeTotalRiskScoreCatagory] | translate }}
      </div>
    </div>
  </div>
  <!--PREDICTION TEXT-->
  <div class="mb-4">{{ predictionText }}</div>

  <!--THIN GREY LINE-->
  <div class="horiz-bar-thin bg-gray-200"></div>
  <!--MYOPIA RISK SCORE-->
  <div class="flex align-items-center mt-4 mb-2">
    <div class="text-800 text-2xl font-medium mr-4">{{ 'MYOPIA_RISK_SCORE_TITLE' | translate }}</div>
    <div class="flex align-items-center">
      <div class="border-round-2xl px-2 py-1 mr-1" [ngStyle]="{ backgroundColor: riskColor, color: riskColorText }">
        {{ premyopeTotalRiskScore }}
      </div>
      <div class="text-800 text-sm">{{" "+' / '}} {{ ageCatagory === PremyopeAgeCategory.LESS_THAN_9_YEARS ? 9 : 6 }}</div>
    </div>
  </div>
  <!--RISK SCORE EXPLAINER-->
  <div class="mb-4 text-gray-400 text-sm">{{ 'MYOPIA_RISK_SCORE_DISCLAIMER' | translate }}</div>
  <!--CHART & BREAK DOWN-->
  <div class="flex align-items-center">
    <!--CHART-->
    <div class="chart-container mr-6" #chartContainer>
      <p-chart type="doughnut" width="300px" height="150px" [data]="data" [options]="options"> </p-chart>
      <img class="indicator" [ngStyle]="indicatorStyle" src="assets/svg/indicator.svg" alt="Indicator" />
    </div>
    <!--BREAKDOWN-->
    <div>
      <div class="text-800 font-semibold mb-2">{{'BREAKDOWN'| translate}}</div>
      <div class="flex align-items-center">
        <div class="mr-2">{{'REFRACTIVE'| translate}} -</div>
        <div
          class="border-round-2xl px-2 py-1 mr-1"
          [ngStyle]="{ backgroundColor: getBreakdownColors(serRiskScore), color: getBreakdownTextColors(serRiskScore) }">
          {{ serRiskScore }}
        </div>
        <div class="text-800 text-sm">{{" "+' / '}} {{ ageCatagory === PremyopeAgeCategory.LESS_THAN_9_YEARS ? 3 : 2 }}</div>
      </div>
      <div class="flex align-items-center">
        <div class="mr-2">{{'AXIAL_LENGTH'| translate}} -</div>
        <div
          class="border-round-2xl px-2 py-1 mr-1"
          [ngStyle]="{ backgroundColor: getBreakdownColors(axialRiskScore), color: getBreakdownTextColors(axialRiskScore) }">
          {{ axialRiskScore }}
        </div>
        <div class="text-800 text-sm">{{" "+' / '}} {{ ageCatagory === PremyopeAgeCategory.LESS_THAN_9_YEARS ? 3 : 2 }}</div>
      </div>
      <div class="flex align-items-center">
        <div class="mr-2">{{'PARENTAL_MYOPIA'| translate}} -</div>
        <div
          class="border-round-2xl px-2 py-1 mr-1"
          [ngStyle]="{backgroundColor: getBreakdownColors(inheritabilityRiskScore), color: getBreakdownTextColors(inheritabilityRiskScore) }">
          {{ inheritabilityRiskScore }}
        </div>
        <div class="text-800 text-sm">{{" "+' / '}} {{ ageCatagory === PremyopeAgeCategory.LESS_THAN_9_YEARS ? 3 : 2 }}</div>
      </div>
    </div>
  </div>
  <!--THIN GREY LINE-->
  <div class="horiz-bar-thin bg-gray-200 mb-4 mt-6"></div>
</div>
